import React from 'react'
import { Image } from '@chakra-ui/react'
const Customer = () => {
    return (
        <div>
            <Image src='customer.png' />
        </div>
    )
}

export default Customer
